import { toastService } from "src/libraries/toast";
import { magazineCategoryModel } from "../entity/magazineCategory/MagazineCategoryModel";
import { magazineCategoryService } from "../entity/magazineCategory/MagazineCategoryService";

export const getMagazineCategoryUseCase = async (id: number) => {
    try {
        const response = await magazineCategoryService.get(id);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            magazineCategoryModel.magazineCategory = response.data;
        }
        return response;
    } catch (error) {
        console.warn('getMagazineCategoryUseCase: ', error);
    }
}